<template>
  <div class="h-dialogContainer h-track-tabPage">
    <div class="row"></div>
    
      <InstanceSliceProfileDetail ref='instanceSliceProfileDetail'></InstanceSliceProfileDetail>
      
      <div class="h-borderBox h-subscriber-parseList h-dp-deploy-style">
        <div class="h-dialog-borderBox-topIcon">
          <span class="h-red-code">* </span>
          {{$t('NSMF.neDeploy')}}
          <div class="h-toolbarBg dialog-icon-style">
            <ejs-toolbar class="dialog-icon-style">
              <div class="dialog-icon-style"></div>
            </ejs-toolbar>
          </div>
        </div>

        <div class="row" v-for="(neType, index) in neTypeList" :key="index">
          <div class="col-sm-6 h-col-inputBox" style="margin-top:10px" id="neDeployBox">
            <ejs-checkbox
              ref="neTypeCheck"
              name="neDeploy"
              :label="neType.label"
              :value="neType.value"
              :checked="neType.checked"
              :change="neTypeChangeFunc"
              :disabled="neType.disabled"
            ></ejs-checkbox>
          </div>
          <div :class='"shared"+neType.value' style="display:none;margin-top:10px" >
            <div class="col-sm-6 h-col-inputBox">
              <div class="h-inputLit">{{$t('NSMF.shareProperty')}}:</div>
              <ejs-dropdownlist
                :dataSource="sharePropertyList"
                :id='"sharedId"+neType.value'
                :name='"shareCheck"+neType.value'
                :fields="fieldsOfShare"
                @change="changeForShare"
              ></ejs-dropdownlist>
            </div>
            <div :class='"sharedNe"+neType.value' style="display:none;margin-top:10px">
              <div class="col-sm-6 h-col-inputBox">
                <div class="h-inputLit">{{$t('NSMF.sharePropertyNe')}}:</div>
                <ejs-dropdownlist
                  :dataSource='shareDataSource.get(neType.value)'
                  :id='"sharedNe"+neType.value'
                  :name='"shareNeCheck"+neType.value'
                  :fields="fieldsOfShareNe"
                  @change="changeForShareNe"
                ></ejs-dropdownlist>
              </div>
            </div>
          </div>         
          <div
            :id='"sliceProfile"+neType.value'
            class="col-sm-12"
            style="display:none;margin-top:10px"
          >
            <ejs-grid
              :dataSource="serviceAllData"
              :ref="'sliceProfileGrid'+neType.value"
              height="auto"
              :rowSelected="clickDeploy"
              :id='"sliceProfileGridId"+neType.value'
            >
           <e-columns>
            <e-column field='deliverType' minWidth='10' :headerText='$t("DeployManagement.deliverTypeStr")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='pkgVersion' minWidth='10' :headerText='$t("DeployManagement.version")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='deployedCount' minWidth='10' :headerText='$t("DeployManagement.deployCount")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='exist' minWidth='10' :headerText='$t("DeployManagement.hasPkg")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
            <e-column field='createTime' minWidth='10' :headerText='$t("DeployManagement.createTime")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>        
           </e-columns>
           </ejs-grid>
          </div>

          <div
            class="col-sm-12"
            :id='"deployCase"+neType.value'
            style="display:none;margin-top:20px"
          >
            <DeployCaseDialog :ref="'deployCase'+neType.value" :oamTypeCodeParent='neType.value'></DeployCaseDialog>
          </div>
        </div>
      </div>

  </div>
</template>
<script>
import { EventBus } from "../../../plugins/eventBus";
import { FormValidator } from "@syncfusion/ej2-vue-inputs";
import DeployCaseDialog from "./deployCaseDialogNsmf";
import InstanceSliceProfileDetail from "./InstanceSliceProfileDetail";

export default {
  name: "AddSliceProfile",
  components: {
    DeployCaseDialog,
    InstanceSliceProfileDetail
  },
  data() {
    return {
      runModeWhole:"1",
      neTypeList: [
        { label: "UDM", value: "36", checked: false },
        { label: "AMF", value: "37", checked: false },
        { label: "SMF", value: "38", checked: false },
        { label: "PCF", value: "39", checked: false },
        { label: "UPF", value: "41", checked: false },
        { label: "NSSF", value: "42", checked: false },
        { label: "NRF", value: "49", checked: false },
        { label: "VDOS", value: "255", checked: true, disabled: true },
        // { label: "OAM_5GC", value: "253", checked: true, disabled: true }
      ],
      shareList:["36","37","42","49"],//目前支持的可共享网元
      netypeAll: ["36", "37", "38", "39", "41","42", "49", "255",  "253"],
      serviceAllData: [],
      existMap: {
        0: this.$t("DeployManagement.exist"),
        1: this.$t("DeployManagement.notExist")
      },
      deliverMap: {
        // 交付方式 0:native 老的enb和epc包 / 1:image 镜像包 / 2:helm 5GC包
        0: "Native",
        1: "Image",
        2: "Helm",
        3: "Vm"
      },
      neMap: {
        // D项目
        42: "NSSF",
        41: "UPF",
        39: "PCF",
        36: "UDM",
        37: "AMF",
        38: "SMF",
        49: "NRF",
        255: "VDOS",
        253: "OAM_5GC",
      },
      neTypeArray: [],
      neDeploy: [],
      neTypeName: "",
      locale: localStorage.getItem("locale"),
      fieldsOfShare: {
        text: "text",
        value: "value"
      },
      fieldsOfShareNe: {
        text: "name",
        value: "value"
      },
      shareDataSource:new Map(),
      udmShareNe: [],
      sharePropertyList: [
        { text: this.$t("NSMF.shareable"), value: "1" },
        { text: this.$t("NSMF.disableShare"), value: "0" }
      ],
      shareForm: {
        "0": this.$t("NSMF.disableShare"),
        "1": this.$t("NSMF.shareable")
      },
      fieldsOfGbps: {
        text: "text",
        value: "value"
      }
    };
  },
  methods: {
    changeForShare(msg) {
      //是否可被共享属性选择1：可被共享
      const sharePropertyId=msg.element.id.replace("sharedId","");
      if (msg.value == 1) {
        document.getElementsByClassName("sharedNe"+sharePropertyId)[0].style.display = "block"; //显示AMF网元列表
        document.getElementById("sliceProfile"+sharePropertyId).style.display = "none"; //隐藏版本列表
        document.getElementById("deployCase"+sharePropertyId).style.display = "none"; //隐藏部署详情页
        //处理不共享改成共享未触发“changeForShareNe”方法：判断头两个字是否是“新建”
        if(document.getElementById("sharedNe" + sharePropertyId).value.substring(0,2) == "新建"){
          let oamCode=sharePropertyId;
          if(sharePropertyId.indexOf("37")!=-1){
            oamCode=37;
          }
          //1为选择新建AMF
          this.getServiceList(oamCode,sharePropertyId);
          document.getElementById("sliceProfile"+sharePropertyId).style.display = "block"; //可被共享显示版本列表
          document.getElementById("deployCase"+sharePropertyId).style.display = "none"; //隐藏部署详情页
        }
      } else {
        let oamCode=sharePropertyId;
        if(sharePropertyId.indexOf("37")!=-1){//amf存在多个，以371，372形式区分
             oamCode=37;
          }
        this.getServiceList(oamCode,sharePropertyId);
        document.getElementsByClassName("sharedNe"+sharePropertyId)[0].style.display = "none"; //不可共享隐藏共享网元信息
        document.getElementById("sliceProfile"+sharePropertyId).style.display = "block"; //显示版本列表
        document.getElementById("deployCase"+sharePropertyId).style.display = "none"; //隐藏部署详情页
      }    
    },
    changeForShareNe(msg) {
      //可被共享AMF网元列表
      const sharePropertyNeId=msg.element.id.replace("sharedNe","");
      let oamCode=sharePropertyNeId;
      if(sharePropertyNeId.indexOf("37")!=-1){
          oamCode=37;
        }
      if (msg.value == 1) {
        //1为选择新建AMF
        this.getServiceList(oamCode,sharePropertyNeId);
        document.getElementById("sliceProfile"+sharePropertyNeId).style.display = "block"; //可被共享显示版本列表
        document.getElementById("deployCase"+sharePropertyNeId).style.display = "none"; //隐藏部署详情页
      } else {
        this.getServiceList(oamCode,sharePropertyNeId);
        document.getElementById("sliceProfile"+sharePropertyNeId).style.display = "none";
        document.getElementById("deployCase"+sharePropertyNeId).style.display = "none"; //隐藏部署详情页
      }
    },
    neTypeChangeFunc(flag) {
      //0是第一次进入；1是第二次
      this.$nextTick(() => {
      this.neTypeArray = this.getArray("neDeployBox", flag);
      this.neDeploy = this.neTypeArray;});
    },
    getArray(id, flag) {
      let checkedDom = [];
      let checkedDomUnCheck = [];
      if (flag == 0) {
        for (var i = 0; i < this.neTypeList.length; i++) {
          if (this.neTypeList[i].checked == true) {
            checkedDom.push(this.neTypeList[i]);
          } else if (this.neTypeList[i].checked == false) {
            checkedDomUnCheck.push(this.neTypeList[i]);
          }
        }
      } else {
        checkedDom = document.querySelectorAll(
          `#${id} [aria-checked=true] input`
        );
        checkedDomUnCheck = document.querySelectorAll(
          `#${id} [aria-checked=false] input`
        );
      }
      const array = [];
      const arrayLabel = [];
      for (let i = 0; i < checkedDom.length; i++) {
        if (this.shareList.indexOf(checkedDom[i].value)!=-1) {//选中包含在共享网元数组里（不包含是-1
          document.getElementsByClassName("shared"+checkedDom[i].value)[0].style.display = "block"; //显示是否共享
        }
        if (this.shareList.indexOf(checkedDom[i].value)==-1) {//选中不包含在共享网元数组里，展示版本列表 
          document.getElementById("sliceProfile" + checkedDom[i].value).style.display = "block"; //显示
          this.getServiceList(checkedDom[i].value,0);
        }
        array.push(checkedDom[i].value);
        if (flag == 0) {
          arrayLabel.push(checkedDom[i].label);
        } else {
          arrayLabel.push(checkedDom[i].ej2_instances[0].label);
        }
      }
      for (let i = 0; i < checkedDomUnCheck.length; i++) {
        if (this.shareList.indexOf(checkedDomUnCheck[i].value)!=-1) {//不包含是-1;不显示 是否共享
          document.getElementsByClassName("shared"+checkedDomUnCheck[i].value)[0].style.display = "none"; //不显示是否共享
        }
        document.getElementById(
          "sliceProfile" + checkedDomUnCheck[i].value
        ).style.display = "none"; //版本列表不显示
        document.getElementById(
          "deployCase" + checkedDomUnCheck[i].value
        ).style.display = "none"; //部署详情不显示
      }

      this.neTypeName = arrayLabel;
      return array;
    },
     getSharedNeList() {
      let shareCode=[36,37,42,49];//共享网元
      let sharedData=[[{name: "新建UDM",value: 1}],[{name: "新建AMF",value: 1}],[{name: "新建NSSF",value: 1}],[{name: "新建NRF",value: 1}]];
      this.$axios.post(`/lte/ems/networkSlice/selectShared`).then(response => {
        if (
          response &&
          response.status === 200 &&
          response.data &&
          response.data.errorCode === "SUCCESS"
        ) {
          const listData = response.data.resultVal;         
          for (var i = 0; i < listData.length; i++) {
            for(var j = 0; j < shareCode.length; j++){
              if(listData[i].added==shareCode[j]){
                sharedData[j].push({
                name: listData[i].neid + "-" + listData[i].alias,
                value: listData[i].neid              
                });
              }
            }
          }
          for(var index = 0; index < shareCode.length; index++){            
            this.shareDataSource.set(String(shareCode[index]),sharedData[index]);
            if(shareCode[index]==37){              
              this.shareDataSource.set("371",sharedData[index]);//目前没有改成简便方法
              this.shareDataSource.set("372",sharedData[index]);
              this.shareDataSource.set("373",sharedData[index]);
              this.shareDataSource.set("374",sharedData[index]);
              this.shareDataSource.set("375",sharedData[index]);
              }            
          }
        }
      });
    },
    getServiceList(oamTypeCode,amfDeploy) {
      let oamModeValue=this.runModeWhole;
      if("255"==oamTypeCode){
        oamModeValue="exclude";
      }
      const url = `/lte/ems/packageManager/queryServiceAll?oamTypeCode=${oamTypeCode}&oamMode=${oamModeValue}`;
      this.$axios.get(url).then(res => {
        const result = res.data;
        const showRe = [];
        let showReHasPkg = [];
        const urlNew = `/lte/ems/packageManager/findUpBackPackage?oamTypeCode=${oamTypeCode}&deliverType=${result[0].deliverType}`;
        // 查询是否存在软件包
        this.$axios.get(urlNew).then(res => {
          showReHasPkg = this.handlerPkgPackage(res.data);
          const detailOperate = this.$t("DeployManagement.detail");
          result.forEach((item, index) => {
            const re = item;
            re.deliverTypeId = item.deliverType;
            re.deliverType = this.deliverMap[item.deliverType];
            re.pkgVersion = item.pkgVersion;
            re.deployedCount = item.deployedCount;
            re.createTime = item.createTime;
            re.serviceName = this.neMap[item.oamTypeCode];
            const reHasPkg = showReHasPkg.filter(
              item => item.deliverVersion == re.pkgVersion
            );
            re.existNum = reHasPkg[0] ? reHasPkg[0].existNum : 1;
            re.exist = this.existMap[re.existNum];
            re.chartPath = reHasPkg[0] ? reHasPkg[0].chartPath : "";
            re.configPath = reHasPkg[0] ? reHasPkg[0].configPath : "";
            showRe.push(re);
          });
          if(amfDeploy==0){//除共享网元之外的
          this.$refs[`sliceProfileGrid${oamTypeCode}`][0].dataSource = showRe;

          }else{
          this.$refs[`sliceProfileGrid${amfDeploy}`][0].dataSource = showRe;

          }
        });
      });
    },

    // 判断是否存在软件包
    handlerPkgPackage(result) {
      const adapter = result.filter(item => item.pkgType === 0);
      const pkg = result
        .filter(item => item.pkgType === 1)
        .map(item => {
          const { packageName, pkgVersion } = item;
          return {
            packageName,
            pkgVersion
          };
        });
      const serverPkg = result
        .filter(item => item.pkgType === 2)
        .map(item => {
          const { packageName, pkgVersion } = item;
          return {
            packageName,
            pkgVersion
          };
        });
      const chartConfig = result
        .filter(item => item.pkgType === 3)
        .map(item => {
          const { packageName, pkgVersion, chartPath, configPath } = item;
          return {
            packageName,
            pkgVersion,
            chartPath,
            configPath
          };
        });
      const showRe = [];
      adapter.forEach(item => {
        const re = { upVersion: [] };
        re.deliverType = item.deliverType;
        re.deliverName = this.deliverMap[item.deliverType];
        re.deliverVersion = item.pkgVersion;
        const tempN = pkg.filter(it => it.packageName === item.packageName);
        const tempS = serverPkg.filter(
          it => it.packageName === item.packageName
        );
        const tempConfig = chartConfig.filter(
          it => it.packageName === item.packageName
        );
        if (Object.keys(tempN).length === 1) {
          // native 类型，检查是否存在升级包pkg(2个)
          re.existNum = 0;
          re.pkgType = 1;
          re.upVersion = tempN.map(re => re.pkgVersion);
        } else if (Object.keys(tempS).length === 1) {
          // image/helm类型，检查是否存在软件包
          re.existNum = 0;
          re.pkgType = 2;
          re.upVersion = tempS.map(re => re.pkgVersion);
        } else {
          re.existNum = 1;
        }
        if (Object.keys(tempConfig).length === 1) {
          // chart，检查是否存在软件包
          re.existNum = 0;
          re.chartPath = tempConfig.map(re => re.chartPath)[0];
          re.configPath = tempConfig.map(re => re.configPath)[0];
        }
        re.exist = this.existMap[re.existNum];
        showRe.push(re);
      });
      return showRe;
    },

    clickDeploy(args) {
      let sendData = args.data;
      let idOnly = args.row.offsetParent.parentElement.offsetParent.id.replace("sliceProfileGridId","");//checkbox设置的ID唯一
      sendData["optionName"] = idOnly;
      document.getElementById(
        "deployCase" + idOnly
      ).style.display = "block"; //显示部署详情
      if (sendData.deliverTypeId === 2) {
        // D项目的helm部署方式
        this.$refs[`deployCase${idOnly}`][0].clear();
        this.$refs[`deployCase${idOnly}`][0].getJson(sendData);
      }
    },

    clear() {
      this.neTypeList = [
        { label: "UDM", value: "36", checked: false },
        { label: "AMF", value: "37", checked: false },
        { label: "SMF", value: "38", checked: false },
        { label: "PCF", value: "39", checked: false },
        { label: "UPF", value: "41", checked: false },
        { label: "NSSF", value: "42", checked: false },
        { label: "NRF", value: "49", checked: false },
        { label: "VDOS", value: "255", checked: true, disabled: true },
      ];
       this.sharePropertyList= [
        { text: this.$t("NSMF.shareable"), value: "1" },
        { text: this.$t("NSMF.disableShare"), value: "0" }
      ];
      this.$forceUpdate();
    },

    initNeConfig(checkData, runModeRadioValue,callback) {
      this.$nextTick(() => {
      this.runModeWhole=runModeRadioValue=="1"?"exclude":"share";//1是oam1对1模式
      this.oamChangeStatus(runModeRadioValue);
      this.$refs.instanceSliceProfileDetail.init(checkData);
      const neConfigShow = JSON.parse(checkData.neConfig);
      let indexList=1;
      neConfigShow.forEach(itemNe => {
        if (itemNe.neType == "UDM") {
          this.neTypeList[0].checked = true;
        } else if (itemNe.neType == "AMF") {
          this.neTypeList[1].checked = true;
          indexList=parseInt(itemNe.num);
          if(itemNe.num>1){
            for(let i=1;i<itemNe.num;i++){
              this.neTypeList.splice(1+i,0,{ label: "AMF", value: "37"+i, checked: true });
              this.shareList.push("37"+i);
            }
          }
        } 
          else if (itemNe.neType == "SMF") {
          this.neTypeList[1+indexList].checked = true;
        } else if (itemNe.neType == "PCF") {
          this.neTypeList[2+indexList].checked = true;
        } else if (itemNe.neType == "UPF") {
          this.neTypeList[3+indexList].checked = true;
        } else if (itemNe.neType == "NSSF") {
          this.neTypeList[4+indexList].checked = true;
        }else if (itemNe.neType == "NRF") {
          this.neTypeList[5+indexList].checked = true;
        }
      });
      if (callback) {
        callback(true);
      }
     });
    },
    getKey(obj, value) {
      for (let key in obj) {
        if (value === obj[key]) {
          return key;
        }
      }
    },
    checkValidate() {
      let neConfigList = [];
      if (this.neDeploy.length == 0) {
        //不勾选任何数据不允许下发
        EventBus.$emit("toast", {
          type: "warning",
          content: this.$t("NSMF.disableSend")
        });
        return false;
      }

      for (var i = 0; i < this.neDeploy.length; i++) {
        const neCodeOne = this.neDeploy[i];
        const isShared = this.getKey(this.shareForm,document.getElementById("sharedId"+neCodeOne).value);
        let sharedValue = "";
        if (document.getElementById("sharedNe"+neCodeOne).value) {
        sharedValue = document.getElementById("sharedNe"+neCodeOne).value.split("-")[0];
        }

       let params = {};
        if (!(this.shareList.indexOf(neCodeOne)!=-1 && isShared == 1 && sharedValue.indexOf( "新建")==-1)) {
          //只有非此种情况（选择共享和共享网元时）时才获取部署信息
          if (
            document.getElementById("deployCase" + neCodeOne).style.display ==
            "block"
          ) {
            //只有打开部署弹框的再获取部署值
            params = this.$refs[
              `deployCase${neCodeOne}`
            ][0].checkGetTemplateJson(); //只校验
            if (!params) {
              return false;
            }
          } else {
            //未打开部署弹窗的时候提示填写部署信息
            EventBus.$emit("toast", {
              type: "warning",
              content: this.$t("NSMF.deployinfo")
            });
            return false;
          }
        }
      }
      return true;
    },
    dataInfo(sliceProfileDetail) {
      if (this.checkValidate()) {
        //先校验，都通过再获取数据

        let neConfigList = [];

        for (var i = 0; i < this.neDeploy.length; i++) {
          const neCodeOne = this.neDeploy[i];

          let params = {};

          const isShared = this.getKey(this.shareForm,document.getElementById("sharedId"+neCodeOne).value);
          let sharedValue = "";
          let sharedText = "";
          if (document.getElementById("sharedNe"+neCodeOne).value) {
          sharedValue = document.getElementById("sharedNe"+neCodeOne).value.split("-")[0];
          sharedText = document.getElementById("sharedNe"+neCodeOne).value.split("-")[1];
         }

          if (!(this.shareList.indexOf(neCodeOne)!=-1 && isShared == 1 && sharedValue.indexOf("新建") == -1)) {
            //只有非此种情况（共享网元且选择共享和共享网元时）时才获取部署信息
            params = this.$refs[`deployCase${neCodeOne}`][0].getTemplateJson();
            console.log("params getTemplateJson", params);
          }

          if (this.shareList.indexOf(neCodeOne)!=-1 &&isShared == 1 &&sharedValue.indexOf("新建") == -1 &&params != undefined) {
            params["sharedId"] = sharedValue;
            params["sharedName"] = sharedText;
          }
          params["neType"] = this.neTypeName[i];
          params["typeCode"] = neCodeOne.indexOf("37")!=-1 ?"37":neCodeOne;//是amf则写37，否则会是371...
          if(this.shareList.indexOf(neCodeOne)!=-1){
            params["shared"] =isShared;
          }
          else{
            params["shared"] ="0";
          }
          if (neCodeOne == 41) {
            //upf定制，目的解析value，每一个组成一个新的param
            const aliasUpf = params.info.alias.split(":")[0];
            const ipUpf = params.info.alias.split(":")[1];
            const upfConfigList=[];
            for (let i = 0; i < params.vo.length; i++) {
              for (let j = 0; j < params.vo[i].resultVal.length; j++) {
                let resultValEvery = params.vo[i].resultVal[j];
                if (resultValEvery.name == "Values.nodeSelector") {
                  const valueSize = resultValEvery.value;
                  for (let k = 0; k < valueSize.length; k++) {
                    const paramsUpf = JSON.parse(JSON.stringify(params));
                    paramsUpf.vo[i].resultVal[j].value = [];
                    paramsUpf.vo[i].resultVal[j].value.push(valueSize[k]);
                    paramsUpf.info.alias = aliasUpf.split(";")[k + 1];//upf每个别名放入每组部署数据内
                    upfConfigList.push(paramsUpf);
                  }
                }
              }
            }
            const ipValue = "";
            for (let k = 0; k < upfConfigList.length; k++) {//ip分割后放入每个部署的UPF中
              for (let i = 0; i < upfConfigList[k].vo.length; i++) {
                for (let j = 0;j < upfConfigList[k].vo[i].resultVal.length;j++) {
                  let resultValEvery = upfConfigList[k].vo[i].resultVal[j];
                  if (resultValEvery.name == "Values.selectIP") {
                    //upf的ip 组合形式 需要分解 “；1.2.3.1；3.4.5.6”
                    resultValEvery.value = ipUpf.split(";")[k + 1];
                  }
                }
              }
            }

            for(let upfSize=0;upfSize<upfConfigList.length; upfSize++){//重新组合的upf list放入neConfigList
              neConfigList.push(upfConfigList[upfSize]);
            }
          } else {
            neConfigList.push(params);
          }
        }
        return {
          name: sliceProfileDetail.name,
          sNSSAIList: sliceProfileDetail.sNSSAIList,
          envId: sliceProfileDetail.environment,
          envIp: sliceProfileDetail.envIpParent,
          neConfig: JSON.stringify(neConfigList)
        };
      }
    },
    getFormData(callback) {
      this.$refs.instanceSliceProfileDetail.getInstanceBase(res => {
        if (!res) {
          if (callback) {
            callback(false);
          }
        } else {
          let sliceProfileDetail = res;
          if (callback) {
            callback(this.dataInfo(sliceProfileDetail));
          }
        }
      });
    },
    oamChangeStatus(runMode){

      const oamData={ label: "OAM_5GC", value: "253", checked: true, disabled: true };       
      const shareData={ text: this.$t("NSMF.shareable"), value: "1" };
      if("2"==runMode){//一对多
        if(this.neTypeList.indexOf(JSON.stringify(oamData)==-1)){//循环数组加入OAM
          this.neTypeList.push(oamData);
        };
        this.sharePropertyList = this.sharePropertyList.filter(function(item) {//共享列表只展示不可共享选项
        return JSON.stringify(item) != JSON.stringify(shareData);
        }); 
      }else if("1"==runMode){
        this.neTypeList = this.neTypeList.filter(function(item) {
        return JSON.stringify(item) != JSON.stringify(oamData);
        });
        if(1==this.sharePropertyList.length){
          this.sharePropertyList.push(shareData);
        };
      }
    },     
  },
  created(){
    this.getSharedNeList();
  },
};

</script>
